/**
 * Gida Header - Fixed
 *
 * @author Takuto Yanagida
 * @version 2022-09-14
 */


window['GIDA'] = window['GIDA'] ?? {};


window['GIDA'].header_fixed = function (id = null, opts = {}) {
	const CLS_ELM     = 'gida-header';
	const CLS_ELM_TOP = 'gida-header-top';

	const CLS_STICKY   = 'sticky';
	const CLS_FLOATING = 'floating';
	const CLS_OFFSET   = 'offset';

	const minWindowWidth      = opts['minWindowWidth']      ?? 600;
	const maxHeaderHeightRate = opts['maxHeaderHeightRate'] ?? 0.2;
	const minSwitchingOffset  = opts['minSwitchingOffset']  ?? 100;
	const minSwitchingTime    = opts['minSwitchingTime']    ?? 200;
	const scrollPaddingOffset = opts['scrollPaddingOffset'] ?? 8;
	const margin              = opts['margin']              ?? 100;

	let elm;
	let elmTop;

	let isEnabled     = false;
	let cmsBarHeight  = 0;
	let lastSwitchedY = 0;
	let lastSwitchedT = Number.MAX_SAFE_INTEGER;
	let origTop       = 0;
	let origMid       = 0;
	let offsetTop     = 0;

	let safePaddingOffset = 0;
	let lvh               = 0;
	let svh               = 0;
	let lastResizedWidth  = 0;

	const isIos = null !== navigator.userAgent.match(/iPad|iPhone|iPod/) || (navigator.platform === 'MacIntel' && 1 < navigator.maxTouchPoints);


	// -------------------------------------------------------------------------


	/**
	 * Scroll Padding Top
	 *
	 * @author Takuto Yanagida
	 * @version 2023-02-10
	 */
	
	function initializeScrollPaddingTop() {
		const de = document.documentElement;
		if (de.getAttribute('data-scroll-padding-top') !== null) return;
		de.setAttribute('data-scroll-padding-top', '');
	
		const mo = new MutationObserver((ms, mo) => update(mo));
		mo.observe(de, { attributes: true });
		update(mo);
	
		function update(mo) {
			const de = document.documentElement;
	
			mo.disconnect();
			de.style.scrollPaddingTop = null;
	
			const v = parseInt(getComputedStyle(de).scrollPaddingTop);
			setScrollPaddingTop('default', Number.isNaN(v) ? 0 : v);
	
			de.style.scrollPaddingTop = getScrollPaddingTop() + 'px';
			mo.observe(de, { attributes: true });
		}
	}
	
	function setScrollPaddingTop(key, val) {
		const de = document.documentElement;
		const at = de.getAttribute('data-scroll-padding-top');
		const vs = at ? new Map(at.split(',').map(e => e.split(':'))) : new Map();
		if (val) {
			vs.set(key, val);
		} else {
			vs.delete(key);
		}
		de.setAttribute('data-scroll-padding-top', [...vs].map(e => e.join(':')).join(','));
	}
	
	function getScrollPaddingTop(without = null) {
		const de = document.documentElement;
		const at = de.getAttribute('data-scroll-padding-top');
		if (!at) return 0;
	
		const vs = at.split(',').map(e => e.split(':')).filter(([key,]) => key !== without).map(([k, v]) => parseInt(v));
		return vs.reduce((a, b) => a + b, 0);
	}
	
	/**
	 * Common Functions
	 *
	 * @author Takuto Yanagida
	 * @version 2022-09-14
	 */
	
	
	const resizeListeners = [];
	const scrollListeners = [];
	
	function onResize(fn, doFirst = false) {
		if (doFirst) fn();
		resizeListeners.push(throttle(fn));
	}
	
	function onScroll(fn, doFirst = false) {
		if (doFirst) fn();
		scrollListeners.push(throttle(fn));
	}
	
	function onLoad(fn) {
		if ('loading' === document.readyState) {
			document.addEventListener('DOMContentLoaded', fn);
		} else {
			setTimeout(fn, 0);
		}
	}
	
	
	// -----------------------------------------------------------------------------
	
	
	onLoad(() => {
		window.addEventListener('resize', () => { for (const l of resizeListeners) l(); }, { passive: true });
		window.addEventListener('scroll', () => { for (const l of scrollListeners) l(); }, { passive: true });
	});
	
	function throttle(fn) {
		let isRunning;
		function run() {
			isRunning = false;
			fn();
		}
		return () => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(run);
		};
	}
	
	
	// -----------------------------------------------------------------------------
	
	
	function getStaticBoundingClientRect(elm) {
		const origPos = elm.style.position;
		elm.style.position = 'static';
		const r = elm.getBoundingClientRect();
		elm.style.position = origPos;
		return r;
	}
	
	function remainingHeight(ancestor, target) {
		return target.getBoundingClientRect().top - ancestor.getBoundingClientRect().top;
	}
	
	function getCmsBarHeight() {
		return parseFloat(getComputedStyle(document.documentElement).marginTop);
	}
	
	function getViewHeight() {
		const el = document.createElement('div');
		const es = document.createElement('div');
		el.style.opacity  = es.style.opacity  = 0;
		el.style.position = es.style.position = 'absolute';
		el.style.height   = '100lvh'
		es.style.height   = '100svh';
		document.body.appendChild(el);
		document.body.appendChild(es);
		const lvh = el.clientHeight;
		const svh = es.clientHeight;
		document.body.removeChild(el);
		document.body.removeChild(es);
		return [lvh, svh];
	}
	
	
	// -----------------------------------------------------------------------------
	
	
	function scrollToHash() {
		const hash = window.location.hash;
		if (!hash || hash.length < 2 || '#' !== hash[0]) return;
		const t = document.getElementById(hash.substring(1));
		if (!t) return;
		setTimeout(() => {
			const spt = parseInt(document.documentElement.style.scrollPaddingTop, 10);
			window.scrollTo(0, t.getBoundingClientRect().top + window.pageYOffset - spt);
		}, 0);
	}
	


	// -------------------------------------------------------------------------


	onLoad(() => {
		initializeScrollPaddingTop();

		elm = id ? document.getElementById(id) : document.getElementsByClassName(CLS_ELM)[0];
		if (!elm) return;
		elmTop = elm.getElementsByClassName(CLS_ELM_TOP)[0] ?? elm;

		onResize(onResizeHandler, true);
		onScroll(update, true);

		scrollToHash();
	});

	function onResizeHandler() {
		if (lastResizedWidth !== window.innerWidth) {
			[lvh, svh] = isIos ? getViewHeight() : [window.innerHeight, window.innerHeight];
			lastResizedWidth = window.innerWidth;
		}
		setEnabled(isStickable());
		if (isEnabled) {
			cmsBarHeight = getCmsBarHeight();
			adjustFloating();
			update(true);
		}
	}

	function setEnabled(flag) {
		if (flag === isEnabled) return;
		if (flag) {
			elm.classList.add(CLS_STICKY);
			elm.style.position = 'sticky';
		} else {
			elm.classList.remove(CLS_STICKY, CLS_FLOATING, CLS_OFFSET);
			elm.style.position = null;
			elm.style.top      = null;

			setScrollPaddingTop('gida-header', null);
		}
		isEnabled = flag;
	}

	function adjustFloating() {
		const r  = getStaticBoundingClientRect(elm);
		const rh = remainingHeight(elm, elmTop);

		origTop   = r.top + window.scrollY;
		origMid   = r.top + window.scrollY + rh;
		offsetTop = Math.ceil(cmsBarHeight - rh);

		safePaddingOffset = Math.ceil(r.bottom + window.scrollY + scrollPaddingOffset);
	}

	function update(force = false) {
		if (!isEnabled) return;
		setFloating(10 < window.pageYOffset);
		setOffset(origMid + margin <= window.scrollY + cmsBarHeight, force);

		setTimeout(() => {
			let po = safePaddingOffset;
			if (elm.classList.contains(CLS_OFFSET)) {
				po = Math.ceil(elm.getBoundingClientRect().height + offsetTop + scrollPaddingOffset);
			}
			setScrollPaddingTop('gida-header', po + (lvh - svh));
		}, 0);
	}

	function setFloating(flag) {
		if (elm.classList.contains(CLS_FLOATING) === flag) return;
		if (flag) {
			elm.classList.add(CLS_FLOATING);
		} else {
			elm.classList.remove(CLS_FLOATING);
		}
	}

	function setOffset(flag, force) {
		if (!force) {
			if (elm.classList.contains(CLS_OFFSET) === flag) return;
			if (Math.abs(lastSwitchedY - window.scrollY) <= minSwitchingOffset) return;
			lastSwitchedY = window.scrollY;
			if (Math.abs(lastSwitchedT - performance.now()) <= minSwitchingTime) return;
			lastSwitchedT = performance.now();
		}
		if (flag) {
			elm.classList.add(CLS_OFFSET);
			elm.style.top = offsetTop + 'px';
		} else {
			elm.classList.remove(CLS_OFFSET);
			elm.style.top = origTop + 'px';
		}
	}


	// Common ------------------------------------------------------------------


	function isStickable() {
		if (window.innerWidth < minWindowWidth) return false;
		if (svh * maxHeaderHeightRate < elmTop.clientHeight) return false;
		return true;
	}

};
